// hooks/useSourcingProducts.js
import { useMutation, useQueryClient } from "react-query";
import { useAxios } from "./useAxios";
import { BASE_API_URL } from "../utils/app-constants";
// Dynamic function that safely interpolates the ID and the cancel endpoint
export const SOURCING_PRODUCT_CANCEL_URL = (id) =>
  `${BASE_API_URL}sourcing-product/${id}/cancel`;

export const useCancelSourcingProduct = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, notes }) => axios.put(SOURCING_PRODUCT_CANCEL_URL(id), { notes }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("sourced-products");
      },
    },
  );
};
